# a throttle function taken from underscore http://underscorejs.org/docs/underscore.html
# @param{fn{} function to throttle
# @params {number} number of milliseconds to wait
# @param {Object} [options] The options object.
throttle = (fn, number, opts={}) ->
    context = args = result = timeout = null

    previous = 0

    later = () ->
        if options.leading == false
            previous = 0
        else
            previous = new Date().getTime()
        timeout = null
        result = fn.apply(context, args)
        if not timeout then context = args = null

    () ->
        now = new Date().getTime()
        if not previous and opts.leading == false then previous = now

        remaining = number - (now - previous)

        context = this
        args = arguments

        if remaining <= 0 or remaining > number
            clearTimeout(timeout)
            timeout = null
            previous = now
            result = fn.apply(context, args)

            if not timeout then context = args = null

        else if not timeout and opts.trailing != false
            timeout = setTimeout(later, remaining)

        result

# Debounce function taken from coffeescript cookbook:
# https://coffeescript-cookbook.github.io/chapters/functions/debounce
# @param {function} function to debounce
# @param {number} number of milliseconds to wait for additional calls
# @param {boolean} should execute the first call immediately
debounce = (fn, threshold=100, execAsap) ->
    timeout = null
    (args...) ->
        obj = this
        delayed = ->
            fn.apply(obj, args) unless execAsap
            timeout = null
        if timeout
            clearTimeout(timeout)
        else if execAsap
            fn.apply(obj, args)
        timeout = setTimeout(delayed, threshold)

module.exports = {
    throttle: throttle,
    debounce: debounce
}



// WEBPACK FOOTER //
// ./node_modules/musecoreui/util/helpers.coffee